import { FastFilter } from '@vlabs/uikit';

import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';

import ReferenceFilterPopover from './popovers/ReferenceFilterPopover';
import SourceFilterPopover from './popovers/SourceFilterPopover';
import StatusFilterPopover from './popovers/StatusFilterPopover';

const withBottomPopover = withPopover({ placement: 'bottom-start' });
const withFastBottomPopover = withBottomPopover(FastFilter);

export const StatusFilterWithBottomPopover = withFastBottomPopover(StatusFilterPopover);
export const SourceFilterWithBottomPopover = withFastBottomPopover(SourceFilterPopover);
export const ReferenceFilterWithBottomPopover = withFastBottomPopover(ReferenceFilterPopover);
